// extracted by mini-css-extract-plugin
export var contrastLow = "_2p-1";
export var externalLink = "_2p-2";
export var externalLinkIcon = "_2p-3";
export var link = "_2p-0";
export var linkLabel = "_2p-4";